import './BackButton.scss';

import { mdiChevronLeft } from '@mdi/js';
import useAuth from 'common/useAuth';
import Button from 'components/Button/Button';
import Icon from 'components/Icon/Icon';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

interface Props {
  backUrl: string;
  backLabel?: string;
  onBackAction?: () => void;
}

const BackButton: React.FC<Props> = (props): React.ReactElement => {
  const { backUrl, backLabel, onBackAction } = props;

  const navigate = useNavigate();
  const location = useLocation();

  const { historyStack } = useAuth();

  const handleGoBack = () => {
    if (
      historyStack.length > 1 ||
      (historyStack.length === 1 && historyStack[0] !== location.pathname)
    ) {
      navigate(-1); // -1 represents goBack
    } else {
      navigate(backUrl);
    }
  };

  return (
    <Button
      className="BackButton"
      onClick={() => {
        onBackAction?.();
        handleGoBack();
      }}
    >
      <Icon path={mdiChevronLeft} />
      {backLabel}
    </Button>
  );
};

export default BackButton;
